
import toast from "react-hot-toast";
import { PRODUCT_LIST, PRODUCT_LIST_FAIL, PRODUCT_LIST_SUCCESS, PRODUCT_STATUS_CHANGE, PRODUCT_STATUS_CHANGE_FAIL, PRODUCT_STATUS_CHANGE_SUCCESS } from "../../actions/admin/customer-actions";

const initialState = {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalPages: 0,
    productStatistics: {},
    productIntakeSummary: {},
    total: 0,
    productsList: [],
};

const customerReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case PRODUCT_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case PRODUCT_LIST_SUCCESS: {
            return {
                ...state,
                productsList: payload.data.data,
                productIntakeSummary: payload.data.productIntakeSummary || {},
                total: payload.data.total,
                totalPages: payload.data.totalPages,
                isLoading: false,
            };
        }

        case PRODUCT_LIST_FAIL: {
            return {
                ...state,
                isLoading: false,
            };
        }

        case PRODUCT_STATUS_CHANGE: {
            return { ...state };
        }

        case PRODUCT_STATUS_CHANGE_SUCCESS: {
            const msg =
                payload?.data?.message ||
                payload?.message ||
                "Status updated successfully";
            toast.success(msg);
            return { ...state };
        }

        case PRODUCT_STATUS_CHANGE_FAIL: {
            toast.error(
                payload?.error?.data?.message || "Failed to update status"
            );
            return { ...state };
        }

        default: {
            return { ...state };
        }
    }
};

export default customerReducer;
